import { CommonModule } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { RouterOutlet, RouterModule } from '@angular/router';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { Subject } from 'rxjs';
import { RegularizationService } from '../../../Model/Regularization/regularization.service';
import { CommonService } from '../../../Model/Common/common.service';
import { TooltipService } from '../../../Util/Tooltip/tooltip.service';
import { DownloadSampleService } from '../../../Model/DownloadSample/download-sample.service';
import { truncateSync } from 'fs';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { LoaderComponent } from '../../../Component/Loader/loader/loader.component';

@Component({
  selector: 'app-regularization-policies',
  standalone: true,
  imports: [CommonModule, RouterOutlet, RouterModule, DataTablesModule,LoaderComponent],
  templateUrl: './regularization-policies.component.html',
  styleUrl: './regularization-policies.component.scss'
})
export class RegularizationPoliciesComponent {
  isDisabled: boolean = false;
  RegularData: any[] = [];
  TableDatas = [];
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;
  dtoptions: DataTables.Settings = {};
  constructor(
    private regularization: RegularizationService,
    protected common: CommonService,
    private download: DownloadSampleService,
    private toast: ToastService
  ) {
    this.common.getPageRights();
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit(): void {
    this.RegularizationRuleSelectUpdate();
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  RegularizationRuleSelectUpdate() {
    this.isDisabled = true;
    this.regularization.RegularizationRuleSelectUpdate({ SelectType: 1, ESS_RegularizationRuleID: 0 }).subscribe({
      next: (response) => {
        this.TableDatas = Object.values(response.Table);
        this.TableDatas.forEach((element:any) => {
          element.WebESSApplicability = response.Table1.filter((e:any) => e.WebESSApplicabilityId == element.WebESSApplicabilityId)[0].ApplicabilityName
        });
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
          this.dtTrigger.next(null);
        });
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }
  exportToExcel() {
    this.isDisabled = true
    const data = {
      SelectType: 'RegularizationPolicyMasterExcel',
      Year: ''
    }
    this.download.ESS_ExcelDump(data).subscribe(
      data => {
        this.RegularData = data;
        if (this.RegularData.length > 0) {
          this.download.exportToExcel(this.RegularData, "RegularizationPolicies_data");
          this.isDisabled = false
        }
        else {
          this.toast.show({ message: 'No Data Found!', type: toastTypeEnum.warning });
          this.isDisabled = false
        }
      });
  }
}
